import { useLocation, useNavigate } from "react-router-dom";

import Button from "../Button/Button";

import "./styles.scss";

import { NavigationButtonsProps } from "./types";

const NavigationButtons = ({
  handleNextButtonClick,
}: NavigationButtonsProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="d-flex action-button-wrapper">
      <Button
        subType="secondary"
        type="button"
        name="Back"
        className="cancel-button"
        onClick={() => navigate(-1)}
      />
      <Button
        subType="primary"
        type="button"
        name={
          pathname === "/contract/witness-and-agent-signatures"
            ? "Submit"
            : "Next"
        }
        className="submit-button"
        onClick={handleNextButtonClick}
      />
    </div>
  );
};

export default NavigationButtons;
